import useSWR from 'swr'
import type { Page } from '@/services/page'

export const directusFetcher = async <T>(url: string): Promise<T> => {
	const response = await fetch(url)
	if (!response.ok) {
		throw new Error('Failed to fetch data')
	}
	return response.json()
}

export const getCacheKey = {
	page: (slug: string) =>
		slug ? `/api/page?slug=${encodeURIComponent(slug)}` : null,
	blogPosts: (page: number, limit: number) =>
		`/api/directus/blog_posts?limit=${limit}&page=${page}`,
}

export const usePageData = (slug: string, fallbackData?: Page) => {
	const { data, error, isLoading, mutate } = useSWR<Page>(
		getCacheKey.page(slug),
		url => directusFetcher<Page>(url),
		{
			fallbackData,
			// Keep first client render stable with ISR HTML.
			revalidateOnMount: false,
			revalidateIfStale: false,
			refreshInterval: 3600000,
			dedupingInterval: 60000,
		}
	)

	return { page: data, isLoading, isError: error, mutate }
}
